/*
 * AppAuthenticators Messages
 *
 * This contains all the text for the AppAuthenticators scene.
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.scenes.AppAuthenticators";

export default defineMessages(scope, {
  header: "an Authenticator App",
});
